import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";
import { constructQueryString } from "../../helpers/Functions";

const api = new APICore();

export const connectFacebookAccount = createAsyncThunk(
  "facebook/connectFacebookAccount",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CONNECT_FACEBOOK, data);
      showSuccess("Facebook connected successfully!");
      return response.data;
    } catch (error) {
      showError(error);
      return rejectWithValue(error);
    }
  }
);

export const createFacebookPost = createAsyncThunk(
  "facebook/createFacebookPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CREATE_FACEBOOK_POST, data);
      showSuccess("Post created successfully!");
      return response.data;
    } catch (error) {
      showError(error);
      return rejectWithValue(error);
    }
  }
);

export const updateFacebookPost = createAsyncThunk(
  "facebook/updateFacebookPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.UPDATE_FACEBOOK_POST, data);
      showSuccess("Post updated successfully!");
      return response.data;
    } catch (error) {
      showError(error);
      return rejectWithValue(error);
    }
  }
);

export const getFacebookPost = createAsyncThunk(
  "facebook/getFacebookPost",
  async (data, { rejectWithValue }) => {
    try {
      const query = constructQueryString(data);
      const response = await api.get(`${Url.GET_FACEBOOK_POST}?${query}`);
      return response.data;
    } catch (error) {
      showError(error);
      return rejectWithValue(error);
    }
  }
);

export const getFacebookPostDetails = createAsyncThunk(
  "facebook/getFacebookPostDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${Url.GET_FACEBOOK_POST_DETAILS}?postId=${data.postId}`
      );
      return response.data;
    } catch (error) {
      showError(error);
      return rejectWithValue(error);
    }
  }
);

export const deleteFacebookPost = createAsyncThunk(
  "facebook/deleteFacebookPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `${Url.DELETE_FACEBOOK_POST}?postId=${data.postId}`
      );
      showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error);
      return rejectWithValue(error);
    }
  }
);
